var React = require("react");
var Radium = require("radium");

var style = {
	base: {
		borderRadius: "100%",
		background: '#03A6DC',
		position: "absolute",
		transform: "scale(0.3)",
		transition: "transform 0.2s ease-in-out",
		padding: 4,
		margin: 2,
		opacity: 0
	},

	checked: {
		transform: "scale(1)",
		opacity: 1
	}
};

module.exports = Radium(
	React.createClass({
		render: function() {
			var me = this, props = me.props;

			return (
				<span style={[
					style.base,
					props.checked ? style.checked : undefined
				]}></span>
			);
		}
	})
);


// WEBPACK FOOTER //
// ./src/components/RadioGroup/Sign.jsx